import { z } from 'zod'

export const DAY_PRESETS = [1, 3, 7, 14, 30] as const
export const VMJ_DAYS_OPTIONS = [3, 5, 7] as const

export const shortTermSearchSchema = z.object({
  mode: z.enum(['stores', 'projects']).optional().default('stores'),
  storeIds: z.array(z.number().int().positive()).optional().default([]),
  referenceStoreIds: z.array(z.number().int().positive()).optional().default([]),
  projectIds: z.array(z.number().int().positive()).optional().default([]),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  btStartDate: z.string().optional(),
  btEndDate: z.string().optional(),
  productIds: z.array(z.number().int().positive()).optional().default([]),
  poolIds: z.array(z.number().int().positive()).optional().default([]),
  tab: z.enum(['forecast', 'backtest']).optional().default('forecast'),
  corrections: z.boolean().optional().default(true),
  vmjDays: z.number().int().min(1).max(14).optional().default(5),
  weekdaysOnly: z.boolean().optional().default(true),
  excludeCensored: z.boolean().optional().default(false),
})

export type ShortTermSearch = z.infer<typeof shortTermSearchSchema>

export const isoDate = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`

const shiftedDay = (offset: number): string => {
  const date = new Date()
  date.setDate(date.getDate() + offset)
  return isoDate(date)
}

export const presetForecastRange = (days: number): { start: string; end: string } => ({
  start: shiftedDay(1),
  end: shiftedDay(days),
})

export const presetBacktestRange = (days: number): { start: string; end: string } => ({
  start: shiftedDay(-days),
  end: shiftedDay(-1),
})

export const defaultForecastRange = (): { start: string; end: string } => presetForecastRange(30)

export const defaultBacktestRange = (): { start: string; end: string } => presetBacktestRange(30)
